import React, { useMemo } from 'react';
import { string, arrayOf, exact, func, bool, shape } from 'prop-types';

import { Icon } from '@atoms';
import { TextInput } from '@atoms/Input';
import { Flex, Typography } from '@mixins';
import { theme } from '@styles';

const EditSocials = ({ socials, isCompany }) => {
  const socialsBlock = useMemo(
    () =>
      socials.map(({ name, icon, handler, placeholder, value }, index) => (
        <Flex
          flexDirection="column"
          alignItems="start"
          key={name}
          mb={index === socials.length - 1 ? 0 : [10, 12]}
          pt={[10, 16]}
          width="100%">
          <Flex mb="6px" alignItems="center">
            <Icon
              color={isCompany ? theme.color.darkRed : theme.color.mintMinded[900]}
              mr={['12px', '14px', '16px']}
              SVG={icon}
              width={[17, 20, 23]}
            />
            <Typography fontSize={['10px', '14px', '16px']} pointer onClick={handler} variant="diatype-400">
              {name}
            </Typography>
          </Flex>
          <TextInput placeholder={placeholder} value={value} onChange={handler} />
        </Flex>
      )),
    [socials, isCompany],
  );

  return socialsBlock;
};

EditSocials.defaultProps = {
  socials: [],
};

EditSocials.propTypes = {
  socials: arrayOf(
    exact({
      name: string,
      value: string,
      placeholder: string,
      handler: func,
      icon: shape({}),
    }),
  ),
  isCompany: bool.isRequired,
};

export default EditSocials;
